"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M18 1H2a1.003 1.003 0 00-.71 1.71L7 8.41V18a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71V8.41l5.71-5.71c.18-.17.29-.42.29-.7 0-.55-.45-1-1-1z"];
//# sourceMappingURL=filter.js.map